import router from "@/lib/router";
import breadcrumb from "@/lib/breadcrumb";
import i18n from "@/lib/i18n";
import menu from "@/lib/menu";

export default {
	install() {
		i18n.mergeLocaleMessage("fr", {
			"breadcrumb.tasks": "Administration des tâches"
		});

		breadcrumb.add([
			{
				path: "/tasks",
				name: "home>tasks"
			}
		]);

		router.addRoutes([
			{
				path: "/tasks",
				name: "tasks",
				component: () => import("./vues/Index.vue"),
				meta: {
					secured: true,
					roles: ["APPLICATION_ADMINISTRATOR"]
				}
			}
		]);

		menu.addEntry({
			label: i18n.t("breadcrumb.tasks") as string,
			icon: "fa fa-tools",
			location: { name: "tasks" },
			roles: ["APPLICATION_ADMINISTRATOR"],
			order: 120
		});
	}
};
